import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from '@core/api';
import { Shop } from '@core/hera-models';

@Injectable({
  providedIn: 'root',
})
export class ShopDataService {
  constructor(
    private apiService: ApiService,
    private http: HttpClient
  ) {}

  getShop(shopId: string): Observable<Shop> {
    const isMock = environment.mock;
    if (isMock) {
      return this.getShopMock();
    }
    return this.apiService
      .get(`shops/${shopId}`, new HttpParams(), new HttpHeaders())
      .pipe(catchError((error) => of(error)));
  }

  getShopMock(): Observable<Shop> {
    return this.http.get<Shop>('./assets/mocks/shops.json');
  }
}
